import 'core-js/es7/array';

export const objectToValuesPolyfill = (object: any) => {
   return Object.keys(object).map(key => object[key]);
 };
 Object.values = Object.values || objectToValuesPolyfill;